export const GET_CONTENT_FAQ_PAGE = 'GET_CONTENT_FAQ_PAGE';
export const GET_CONTENT_FAQ_PAGE_SUCCESS = 'GET_CONTENT_FAQ_PAGE_SUCCESS'

export function getPageContent() {
  return {
    type: GET_CONTENT_FAQ_PAGE,
    pageType: 'faqPage'
  }
}

export function getPageContentSuccess(content) {
  return {
    type: GET_CONTENT_FAQ_PAGE_SUCCESS,
    content
  }
}